import { render, staticRenderFns } from "./ColumnWithRotatedLabels.vue?vue&type=template&id=5faf2d2a&scoped=true&"
import script from "./ColumnWithRotatedLabels.vue?vue&type=script&lang=js&"
export * from "./ColumnWithRotatedLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faf2d2a",
  null
  
)

export default component.exports